import { EventView, TaskView } from '@ndvr/customer-api';

export enum PriorityType {
    EVENT = 'event',
    TASK = 'task',
    FOLLOWUP = 'followup',
}

export type Priority =
    | {
          type: PriorityType.EVENT;
          data: EventView;
      }
    | {
          type: PriorityType.TASK;
          data: TaskView;
      }
    | {
          type: PriorityType.FOLLOWUP;
          data: EventView;
      };
